// Imports ------------------------------------------------------------------->

import {attr, Component, handler} from "../Component";
import { element } from "../CustomElement";

import {LoginButton, LoginContext} from "../flipp-login-button/LoginButton";
import { AuthProvider } from "../../definitions/CommonDefinitions";
import {Dialog} from "../flipp-dialog/Dialog";


interface SocialIconsContainerProps extends JSX.HTMLProps {
	isDisabled?: string;
	buttonClick?: () => void;
}

@element("flipp-social-icons-container")
export class SocialIconsContainer extends Component<SocialIconsContainerProps, void> {
	@attr isDisabled: string;
	@handler buttonClick: () => void;

	refs: {
		googleBtn: HTMLElement;
		facebookBtn: HTMLElement;
	};

	onAttributeChange(name: string, oldVal: string, newVal: string) {
		super.onAttributeChange(name, oldVal, newVal);
		if (this.refs.googleBtn) {
			this.refs.googleBtn.setAttribute("isDisabled", newVal);
			this.refs.facebookBtn.setAttribute("isDisabled", newVal);
		}
	}

	render() {
		return (
			<div class="social-icon-container">
				<div class="social-icon">
					<LoginButton ref="googleBtn" buttonClick={this.buttonClick}  isDisabled={"true"} provider={AuthProvider.GOOGLE} context="signin" round={false} />
				</div>
				<div class="social-icon">
					<LoginButton ref="facebookBtn" buttonClick={this.buttonClick} isDisabled={"true"} provider={AuthProvider.FACEBOOK} context="signin" round={false} />
				</div>
			</div>
		);
	}
}
